<template>
  <header>
    <figure>
      <svg
        class="logo"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 396.85 198.43"
      >
        <g fill="#ca4f55">
          <path
            d="M4.9 120.89H1.1a.83.83 0 0 1-.83-.83v-.32a.83.83 0 0 1 .83-.82h3.8a1.43 1.43 0 0 0 1.42-1.42v-11.6a1.42 1.42 0 0 1 1.07-1.38l17.5-4.33a1.41 1.41 0 0 1 1.76 1.37v15.94a1.43 1.43 0 0 0 1.42 1.42h12a.83.83 0 0 1 .83.82v.32a.83.83 0 0 1-.83.83h-12a1.42 1.42 0 0 0-1.42 1.41v35.49c0 6.46 1 10 4.81 10 5.06 0 8.29-4.48 9.4-11.47a.82.82 0 0 1 .91-.7H42a.84.84 0 0 1 .73.94c-1.13 8.21-4.92 15.59-17.83 15.59-10.82 0-18.58-3.18-18.58-16.76V122.3a1.42 1.42 0 0 0-1.42-1.41z"
          />
          <path
            d="M67.98 90.33v32.62a1.41 1.41 0 0 0 2.56.82c2.41-3.36 6.43-5.95 13.73-5.95 10.17 0 16.94 5 16.94 18.29v31.54a1.42 1.42 0 0 0 1.42 1.42h3.88a.83.83 0 0 1 .83.83v.31a.83.83 0 0 1-.83.83H77.22a.83.83 0 0 1-.82-.83v-.31a.83.83 0 0 1 .82-.83h2.24a1.42 1.42 0 0 0 1.42-1.42v-34.17c0-9.31-1.31-10.4-4.05-10.4-4.59 0-8.85 6.9-8.85 15.77v28.8a1.41 1.41 0 0 0 1.42 1.42h2.5a.83.83 0 0 1 .83.83v.31a.83.83 0 0 1-.83.83H42.46a.83.83 0 0 1-.83-.83v-.31a.83.83 0 0 1 .83-.83h3.77a1.41 1.41 0 0 0 1.41-1.42V92.3a1.42 1.42 0 0 0-1.41-1.42h-3.77a.83.83 0 0 1-.83-.83v-.31a.83.83 0 0 1 .83-.83h24.1a1.42 1.42 0 0 1 1.42 1.42zM138.21 117.82c16.67 0 24.06 8.16 23.87 23.59a1.42 1.42 0 0 1-1.42 1.38h-28a1.42 1.42 0 0 0-1.42 1.42v2.85c0 12.92 2.3 21.68 12.9 21.68 7.87 0 13.25-4.86 15.76-12.88a.83.83 0 0 1 .92-.58l.34.06a.83.83 0 0 1 .66 1.05c-2.63 9-8.44 15.75-23.47 15.75-19.46 0-28.21-11.17-28.21-27.05-.03-18.95 12.87-27.27 28.07-27.27zm2.95 22.75a1.42 1.42 0 0 0 1.42-1.42v-3.95c0-11.5-.87-15.33-5.35-15.33-3.83 0-5.91 3.72-5.91 15.33v3.95a1.43 1.43 0 0 0 1.42 1.42zM190.55 139.72v27.93a1.41 1.41 0 0 0 1.41 1.42h5.52a.83.83 0 0 1 .83.83v.31a.83.83 0 0 1-.83.83h-32.45a.83.83 0 0 1-.83-.83v-.31a.83.83 0 0 1 .83-.83h3.76a1.41 1.41 0 0 0 1.42-1.42V122.3a1.41 1.41 0 0 0-1.42-1.41h-3.76a.83.83 0 0 1-.83-.83v-.32a.83.83 0 0 1 .83-.82h24.1a1.42 1.42 0 0 1 1.42 1.41v2.65a1.41 1.41 0 0 0 2.57.81 14.6 14.6 0 0 1 12.08-6c6.45 0 11.59 3.4 11.59 11.72 0 6.24-3.29 10.4-9.19 10.4-7 0-10.47-4.16-8.82-11.25a1.43 1.43 0 0 1 1.39-1.12h1.92a1.41 1.41 0 0 0 1.31-.89c1.49-3.75-.55-4.7-2.69-4.7-5.24.03-10.16 7.92-10.16 17.77zM245.9 145.31a1.42 1.42 0 0 0 1.41-1.42v-7c0-13.91-1.2-17.53-5.57-17.53-2 0-5.14.88-5.14 4.38a8.47 8.47 0 0 0 .32 2.13 1.43 1.43 0 0 0 1.38 1h.68a1.42 1.42 0 0 1 1.35 1 13.08 13.08 0 0 1 .53 3.94c0 5.15-4.15 8.54-9.62 8.54-6.78 0-9.4-3.72-9.4-9.09 0-9.2 8-13.47 22.85-13.47 17.16 0 23 4.82 23 20.7v22.23c0 4.49 1.31 5.69 3.17 5.69s3.71-1.95 4.32-10.44a.83.83 0 0 1 .88-.78.83.83 0 0 1 .77.88c-.68 12.47-4.75 16-13.95 16-7.11 0-11.69-1.77-13.89-5.24a1.43 1.43 0 0 0-2.46 0c-1.95 3.4-5.2 5.22-11.31 5.22-7.65 0-16.18-2.3-16.18-13.25s9.51-13.58 25.14-13.58zm1.41 11.94v-10.19h-.76c-4.59 0-6.78 3.29-6.78 10v1.75c0 7.88.77 9 2.84 9s4.67-3.56 4.67-10.56zM302.9 122.39a1.42 1.42 0 0 0 2.51.91c2.58-3.27 6.45-5.48 12.58-5.48 12.25 0 19.79 8.65 19.79 27.27s-7.65 27.05-22.52 27.05c-5 0-7.9-.9-9.84-2.53a1.41 1.41 0 0 0-2.3 1.11v23a1.43 1.43 0 0 0 1.42 1.42h11.86a.83.83 0 0 1 .83.82v.32a.83.83 0 0 1-.83.83h-38.8a.83.83 0 0 1-.82-.83v-.32a.82.82 0 0 1 .82-.82h3.77a1.43 1.43 0 0 0 1.42-1.42V122.3a1.42 1.42 0 0 0-1.42-1.41h-3.47a.83.83 0 0 1-.83-.83v-.32a.83.83 0 0 1 .83-.82h23.67a1.41 1.41 0 0 1 1.41 1.41zm.22 15.25v20c0 5.92 2.3 11.28 7.11 11.28 5.36 0 6.45-6.46 6.45-21.68v-5.67c0-15.45-1.31-19.06-5-19.06-4.48.06-8.53 5.6-8.53 15.13zM339.19 118.92h30.05a.83.83 0 0 1 .83.82v.32a.83.83 0 0 1-.83.83h-3.12a1.42 1.42 0 0 0-1.35 1.86l10 30.51a1.42 1.42 0 0 0 2.69 0l10.65-30.52a1.42 1.42 0 0 0-1.34-1.88h-4.51a.83.83 0 0 1-.82-.83v-.32a.82.82 0 0 1 .82-.82h13.76a.83.83 0 0 1 .83.82v.32a.83.83 0 0 1-.83.83h-3.62a1.4 1.4 0 0 0-1.34.95l-20.16 58.1c-4.92 14.13-10.6 18.51-19.24 18.51-8.2 0-13.67-4.16-13.67-11.06 0-5.47 3.5-8.87 8.75-8.87 5.57 0 9.07 2.41 9.07 7.56a13 13 0 0 1-.36 2.82 1.44 1.44 0 0 1-1.39 1.12h-1.65a1.41 1.41 0 0 0-1.38 1.08c-.61 2.74.22 4.72 3 4.72 6.12 0 10.49-6.13 14.64-18l1.74-4.9a1.42 1.42 0 0 0-1.34-1.89h-6.63a1.39 1.39 0 0 1-1.32-.92l-18-48.31a1.42 1.42 0 0 0-1.33-.92h-2.67a.83.83 0 0 1-.83-.83v-.32a.83.83 0 0 1 .9-.78zM26.68 15v16.1a1.41 1.41 0 0 0 1.42 1.47h12.18a.83.83 0 0 1 .83.83v.31a.83.83 0 0 1-.83.83H28.1a1.42 1.42 0 0 0-1.42 1.42v45.35a1.42 1.42 0 0 0 1.42 1.42h11.09a.83.83 0 0 1 .83.82v.32a.83.83 0 0 1-.83.83h-38a.83.83 0 0 1-.83-.83v-.32a.83.83 0 0 1 .83-.82H4.9a1.42 1.42 0 0 0 1.41-1.42v-45.4a1.42 1.42 0 0 0-1.41-1.42H.8a.83.83 0 0 1-.83-.83v-.31a.83.83 0 0 1 .83-.83h5.51v-.44C6.31 12.15 12.76 0 32.44 0c13.67 0 17.39 6.89 17.39 12.26 0 6.57-3.94 9.53-9.08 9.53-5.9 0-8.74-3.29-8.74-7.78a18.19 18.19 0 0 1 .4-3.59A1.42 1.42 0 0 1 33.8 9.3h2a1.42 1.42 0 0 0 1.36-1c1.31-4.61-1-6.42-3.72-6.42-5.89-.02-6.76 4.8-6.76 13.12z"
          />
          <path
            d="M81.05 83.44l-.38-2.55a1.42 1.42 0 0 0-2.54-.65c-2.32 3.28-6.13 5.5-13.51 5.5-10.17 0-17-5-17-18.29V35.91a1.42 1.42 0 0 0-1.42-1.42h-5.7a.83.83 0 0 1-.82-.83v-.31a.83.83 0 0 1 .82-.83h26a1.42 1.42 0 0 1 1.42 1.42v36.14c0 9.31 1.31 10.73 4 10.73 4.37 0 7.76-4.49 7.76-12.81V35.91a1.42 1.42 0 0 0-1.41-1.42h-2.79a.83.83 0 0 1-.82-.83v-.31a.83.83 0 0 1 .82-.83H98.6a1.42 1.42 0 0 1 1.42 1.42v47.32a1.42 1.42 0 0 0 1.42 1.42h3.76a.83.83 0 0 1 .83.82v.32a.83.83 0 0 1-.83.83H82.46a1.43 1.43 0 0 1-1.41-1.21zM158.1 34.13a1.46 1.46 0 0 1-.17.68l-25.74 47.87h1.42c12.28 0 18.51-6.07 22.46-19.88a.82.82 0 0 1 .79-.6.82.82 0 0 1 .83.89l-1.58 20.25a1.42 1.42 0 0 1-1.41 1.31h-43.18a1.43 1.43 0 0 1-1.42-1.42.9.9 0 0 1 .1-.39l26.25-48.33h-1.2c-14.54 0-18.42 3.35-22.77 18a1.43 1.43 0 0 1-1.36 1h-.36l1.33-19.71a1.42 1.42 0 0 1 1.41-1.23h43.18a1.42 1.42 0 0 1 1.42 1.42zM212.22 34.13a1.46 1.46 0 0 1-.17.68l-25.74 47.87h1.42c12.28 0 18.51-6.07 22.46-19.88a.82.82 0 0 1 .79-.6.82.82 0 0 1 .83.89l-1.58 20.25a1.42 1.42 0 0 1-1.41 1.31h-43.18a1.42 1.42 0 0 1-1.42-1.42.78.78 0 0 1 .1-.39l26.25-48.33h-1.2c-14.54 0-18.42 3.35-22.77 18a1.43 1.43 0 0 1-1.36 1h-.34l1.33-19.71a1.42 1.42 0 0 1 1.41-1.32h43.16a1.42 1.42 0 0 1 1.42 1.42z"
          />
        </g>
      </svg>
    </figure>
  </header>

  <main>
    <div id="heart-wrap">
      <svg
        id="heart"
        xmlns="http://www.w3.org/2000/svg"
        width="68"
        height="58"
        viewBox="0 0 68 58"
      >
        <path
          fill="#ca4f55"
          fill-rule="nonzero"
          d="M62.802 4.677C59.608 1.56 55.195 0 49.562 0c-1.559 0-3.15.27-4.771.81A19.304 19.304 0 0040.265 3a48.299 48.299 0 00-3.602 2.583 34.788 34.788 0 00-2.867 2.565 34.87 34.87 0 00-2.866-2.565C29.924 4.778 28.723 3.917 27.327 3A19.316 19.316 0 0022.801.81C21.179.27 19.588 0 18.03 0 12.397 0 7.984 1.56 4.79 4.677 1.597 7.795 0 12.12 0 17.652c0 1.685.296 3.42.887 5.205.59 1.786 1.263 3.307 2.018 4.564A33.385 33.385 0 005.469 31.1c.956 1.195 1.654 2.018 2.094 2.47.44.453.786.78 1.037.98l23.537 22.707c.452.454 1.006.68 1.66.68a2.26 2.26 0 001.659-.679l23.5-22.632c5.757-5.757 8.637-11.415 8.637-16.973 0-5.532-1.598-9.857-4.791-12.975z"
        />
      </svg>
    </div>

    <div class="content">
      <div class="content__text">
        <h1>
          Intelligent, creative <strong>web design & development</strong> that
          gets results
        </h1>
      </div>
    </div>
  </main>

  <footer>
    <span class="legal"
      >&copy; 2021 Fuzz Therapy
      <a
        href="https://www.gocomics.com/calvinandhobbes/1986/12/08"
        target="_blank"
        rel="nofollow"
        >?</a
      ></span
    >
    <a class="contact" href="mailto:hello@fuzztherapy.co.uk">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="74"
        height="77"
        viewBox="0 0 74 77"
      >
        <path
          fill="#222"
          d="M70.152 29.795L63.256 22.9V7.727a2 2 0 00-2-2H46.085L43.148 2.79c-3.718-3.719-9.771-3.721-13.492 0l-2.937 2.937H11.774a2 2 0 00-2 2V21.69l-7.211 8.197-.014.02A9.796 9.796 0 000 36.507v29.755c0 5.418 4.408 9.825 9.826 9.825h53.379c5.418 0 9.826-4.407 9.826-9.825V36.507c0-2.544-.969-4.803-2.879-6.712zm-1.121 6.712v29.755a5.775 5.775 0 01-.807 2.943L50.897 51.876l11.556-11.555c.15-.113.283-.246.396-.396l5.669-5.669c.342.695.513 1.434.513 2.251zm-3.121-5.298l-2.653 2.653v-5.306l2.653 2.653zM32.484 5.619a5.546 5.546 0 017.835 0l.108.108h-8.052l.109-.108zm26.772 4.108v28.134L40.317 56.799a5.55 5.55 0 01-7.836 0L13.774 38.091V9.727h45.482zM4.805 69.202A5.782 5.782 0 014 66.262V36.507c0-.738.14-1.459.403-2.131l17.614 17.615L4.805 69.202zm4.969-35.111l-2.969-2.969 2.969-3.376v6.345zm.052 37.996c-.673 0-1.317-.12-1.918-.331l16.937-16.937 4.808 4.808a9.514 9.514 0 006.746 2.789c2.443 0 4.886-.93 6.746-2.789l4.923-4.923 17.051 17.053c-.601.21-1.243.33-1.915.33H9.826z"
        />
        <path
          id="writing"
          fill="#ca4f55"
          d="M21.53 20.061h29.971a2 2 0 000-4H21.53a2 2 0 000 4zM21.53 29.228h29.971a2 2 0 000-4H21.53a2 2 0 000 4zM21.53 38.394h18.985a2 2 0 000-4H21.53a2 2 0 000 4z"
        />
      </svg>
    </a>
  </footer>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
@import "./assets/scss/normalize";

// Variables
$red: #ca4f55;
$offwhite: #f7f4f4;
$grey: #222;

// Basics
html {
  box-sizing: border-box;
}

*,
*::after,
*::before {
  box-sizing: inherit;
}

body {
  font-family: "IBM Plex Sans", sans-serif;
  font-weight: 300;
  color: $grey;
  background-color: $offwhite;
  overflow: hidden;
}

a {
  color: $red;
}

strong {
  font-weight: 500;
  color: $offwhite;
}

// JS set fade in
.js body {
  opacity: 0;
  transition: opacity 300ms;

  &.render {
    opacity: 1;
  }
}

header {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  padding: 5vmin;

  // Logo
  svg.logo {
    width: 100%;
    max-width: 160px;
    height: auto;
  }
}

// Layout
main {
  position: relative;
  height: 100vh;
}

#heart-wrap {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 2.5rem;
}

.content__text {
  max-width: 20rem;
  text-align: center;

  @media (max-width: 414px) {
    max-width: 18rem;
  }

  h1 {
    font-weight: 300;
    font-size: 2rem;
    line-height: 1.2;
    margin: 0 0 5vmin;

    @media (max-width: 414px) {
      font-size: 1.5rem;
    }
  }
}

footer {
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5vmin;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  span.legal {
    font-size: 14px;
  }

  a.contact {
    display: block;
    line-height: 1;
    margin: 0;
    padding: 0;
    transition: all 300ms ease;

    &:hover {
      transform: translateY(-4px);
    }

    svg {
      width: 2rem;
      height: auto;
    }
  }
}

// Heart
svg#heart {
  width: 100%;
  max-width: 50vmin;
  height: auto;

  @media (max-width: 768px) {
    max-width: 75vmin;
  }
}
</style>
